<template>

<app-item route="Location" :id="item.id" id-name="location" :selected="selected" v-on:shiftclick="$emit('shiftclick')">

	<app-item-badge :image="item.logo" :flag="item.flag" />

	<app-item-title :text="$highlight(item.title, highlight)" />

	<app-item-count route="Location.Groups" :params="{location: item.id}" tooltip="View groups" :count="useCount" />

</app-item>

</template>

<script>

export default {

	props: ['item', 'highlight', 'selected'],

	computed: {
	
		useCount: function() {

			var locationId = this.item.id

			var textIndex = this.$_.pluck(this.$_.where(this.$store.getters['texts'], {
				'location': locationId
			}), 'id')

			// every group that references the location, whether or not that
			// reference is currently visible: a hidden section or block still points
			// at the location and still has to be dealt with when it changes, so it
			// counts as a use. page/Groups.vue applies the same rule to the list this
			// count links to - the two have to agree
			var matchingGroups = this.$_.filter(this.$store.getters['groups'], function(group) {

				if (this.$_.intersection(group.texts, textIndex).length > 0) return true

				if (group.format) {

					var matched = false

					this.$_.each(group.content, function(section) {

						this.$_.each(section.blocks, function(block) {

							if (block.location && !matched) {

								matched = block.location === locationId

							}

						}.bind(this))

					}.bind(this))

					return matched

				}

				return false

			}.bind(this))

			return matchingGroups.length

		}
	
	}

}

</script>

<style scoped>

</style>
